import { IGetFuncionarioByIdUsuarioUseCase } from "../../../presentation/useCases/read/get_funcionario_by_id_usuario_use_case";
import { FuncionarioInformation } from "../../models/funcionario_information";
import { ICommonsRepository } from "../../repositories/commons_repository";

/**
 * GetFuncionarioByIdUsuarioUseCase
 */

export class GetFuncionarioByIdUsuarioUseCase implements IGetFuncionarioByIdUsuarioUseCase {
  constructor(private readonly repository: ICommonsRepository) { }

  async getFuncionarioByIdUsuario(
    idUsuario: number,
  ): Promise<FuncionarioInformation | null> {
    const response = await this.repository.getFuncionarioByIdUsuario(idUsuario);
    return response;
  }
}
